module.exports = __webpack_public_path__ + "static/img/dragontiger2_th.8e0aa27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/dragontiger2_th.png
// module id = 1TRz
// module chunks = 1